module.exports = new __parcel__URL__("2.c5aeb32e.svg").toString();